import { FORM_SUBMIT, UPDATE_FORM_STATE } from './actionTypes';

export const submitForm = (payload) => ({
  type: FORM_SUBMIT,
  payload: payload
});


export const updateFormState = (formKey, state) => ({
  type: UPDATE_FORM_STATE,
  payload: {[formKey]: state}
})


// WEBPACK FOOTER //
// ./src/actions/form.js